import { render, staticRenderFns } from "./editCompanyName.vue?vue&type=template&id=f2e7b0f6&scoped=true"
import script from "./editCompanyName.vue?vue&type=script&lang=ts"
export * from "./editCompanyName.vue?vue&type=script&lang=ts"
import style0 from "./editCompanyName.vue?vue&type=style&index=0&id=f2e7b0f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e7b0f6",
  null
  
)

export default component.exports